// extracted by mini-css-extract-plugin
module.exports = {"header":"PaymentMethod_header_1fwSV","title":"PaymentMethod_title_3Qr2A","list":"PaymentMethod_list_3S6dH"};